import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

let taxPromise = null;
export const loadTaxonomy = () => {
  if (!taxPromise) taxPromise = api.get("/red/taxonomia").then((r) => r.data).catch((e) => { taxPromise = null; throw e; });
  return taxPromise;
};

export const useTaxonomy = () => {
  const [tax, setTax] = useState(null);
  useEffect(() => { loadTaxonomy().then(setTax).catch(() => {}); }, []);
  return tax;
};

export const norm = (s) => (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

export const serviceName = (tax, key) => tax?.servicios.find((s) => s.clave === key)?.nombre || key;

export const refreshRed = () => window.dispatchEvent(new Event("red:refresh"));

// Componentes montados a la vez comparten una sola petición en vuelo.
let estadoInflight = null;
const fetchEstado = () => {
  if (!estadoInflight) estadoInflight = api.get("/red/estado").finally(() => { estadoInflight = null; });
  return estadoInflight;
};

export const useRedEstado = () => {
  const [estado, setEstado] = useState(null);
  const reload = useCallback(() => fetchEstado().then((r) => setEstado(r.data)).catch(() => {}), []);
  useEffect(() => {
    reload();
    const onVisible = () => document.visibilityState === "visible" && reload();
    const onSw = (e) => e.data?.type === "push" && reload();
    window.addEventListener("red:refresh", reload);
    document.addEventListener("visibilitychange", onVisible);
    navigator.serviceWorker?.addEventListener("message", onSw);
    return () => {
      window.removeEventListener("red:refresh", reload);
      document.removeEventListener("visibilitychange", onVisible);
      navigator.serviceWorker?.removeEventListener("message", onSw);
    };
  }, [reload]);
  useEffect(() => {
    if (!estado?.pendientes) return undefined;
    const t = setTimeout(reload, 3000);
    return () => clearTimeout(t);
  }, [estado, reload]);
  return [estado, reload, setEstado];
};
